'use client';

import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Modal } from '@shared/ui/Modal';

import { closeAuthModal } from '../../model/slice/authSlice';
import { Login } from './Login/Login';
import { VerificationCode } from './VerificationCode/VerificationCode';
import cls from './AuthModal.module.scss';

export const AuthModal = () => {
  const dispatch = useAppDispatch();
  const step = useAppSelector((state) => state.auth.step);
  const openModal = useAppSelector((state) => state.auth.modalIsOpen);

  const closeModalHandler = () => {
    dispatch(closeAuthModal());
  };

  return (
    <Modal
      onClose={closeModalHandler}
      isOpen={openModal}
    >
      <div
        data-testid={'auth-modal'}
        className={cls.content}
      >
        {step === 'login' && <Login />}
        {step === 'verify' && <VerificationCode />}
      </div>
    </Modal>
  );
};
